var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ViewComponent } from '../view/view.component';
import { QuestionnaireService } from './questionnaire.service';
import { ItemBase } from '../../models/item/item-base';
var QuestionnaireAnswerComponent = /** @class */ (function (_super) {
    __extends(QuestionnaireAnswerComponent, _super);
    function QuestionnaireAnswerComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    QuestionnaireAnswerComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.cols = [];
        this.rec = {};
        this.dispRec = {};
    };
    QuestionnaireAnswerComponent.prototype.onSubscribe = function (data) {
        if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            if (data.items.length > 0 && typeof data.items[0]['form_type'] !== 'undefined') {
                this.setFormData(data.items);
            }
            else {
                this.setAnswerData(data.items);
            }
        }
    };
    QuestionnaireAnswerComponent.prototype.setFormData = function (items) {
        var cols = [];
        var rec = {};
        this.service.sortItems(items);
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var col = {};
            if (item.form_type === 'paging') {
                continue;
            }
            else if (item.form_type === 'image') {
                col = {
                    label: '',
                    readonly: true,
                    items: [{
                            key: 'questionnaire-' + item.id,
                            controlType: 'img'
                        }, {
                            controlType: 'break'
                        }, {
                            controlType: 'label',
                            label: item.description
                        }]
                };
                rec['questionnaire-' + item.id] = item.image_path;
            }
            else if (item.form_type === 'title') {
                col = {
                    label: '',
                    readonly: true,
                    items: [{
                            controlType: 'label',
                            label: item.name
                        }, {
                            controlType: 'break'
                        }, {
                            controlType: 'label',
                            label: item.description
                        }]
                };
            }
            else {
                col = {
                    label: 'Q.' + item.q_no + '  ' + item.name,
                    readonly: true,
                    params: {
                        note: item.description
                    },
                    items: [{
                            key: 'questionnaire-' + item.id,
                            controlType: item.form_type
                        }]
                };
                if (item.form_type === 'radio' || item.form_type === 'checkbox' || item.form_type === 'select') {
                    var options = [];
                    this.service.sortItems(item.questionnaire_form_element_m);
                    for (var _a = 0, _b = item.questionnaire_form_element_m; _a < _b.length; _a++) {
                        var element = _b[_a];
                        if (element.is_other_field) {
                            options.push({ code: '0', display: 'その他' });
                            if (typeof this.dispRec['questionnaire-' + item.id + '-other'] !== 'undefined') {
                                col['items'].push({
                                    controlType: 'break'
                                });
                                col['items'].push({
                                    key: 'questionnaire-' + item.id + '-other',
                                    controlType: 'text',
                                });
                            }
                        }
                        else {
                            options.push({ code: element.key, display: element.label });
                        }
                    }
                    col['items'][0]['params'] = { options: options };
                }
            }
            cols.push(Object.assign(new ItemBase(), col));
        }
        this.cols = cols;
        this.dispRec = Object.assign({}, this.dispRec, rec);
    };
    QuestionnaireAnswerComponent.prototype.setAnswerData = function (items) {
        var rec = {};
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            var val = item.value;
            if (item.is_other_filed) {
                rec['questionnaire-' + item.questionnaire_form_id + '-other'] = val;
                val = '0';
            }
            if (typeof rec['questionnaire-' + item.questionnaire_form_id] !== 'undefined') {
                var vals = rec['questionnaire-' + item.questionnaire_form_id];
                if (!(vals instanceof Array)) {
                    vals = [vals];
                }
                vals.push(val);
                rec['questionnaire-' + item.questionnaire_form_id] = vals;
            }
            else {
                rec['questionnaire-' + item.questionnaire_form_id] = val;
            }
        }
        this.dispRec = Object.assign({}, this.dispRec, rec);
    };
    QuestionnaireAnswerComponent.prototype.onEvent = function (e1, e2, index) {
    };
    QuestionnaireAnswerComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'questionnaire-answer',
                    template: "<form *ngIf=\"defMode === '' || defMode === mode\" id=\"{{ componentName }}\">\n  <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n    <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n      <div class=\"row\" [class.-mb-1]=\"index < cols.length - 1\">\n        <div class=\"col-sm-12\">\n          <column [key]=\"'form'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\" (clickCol)=\"onClick($event)\"></column>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template #elseBlock>\n      <columngroup [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" (changeVal)=\"onChange($event)\"></columngroup>\n    </ng-template>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    QuestionnaireAnswerComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: QuestionnaireService }
    ]; };
    return QuestionnaireAnswerComponent;
}(ViewComponent));
export { QuestionnaireAnswerComponent };
//# sourceMappingURL=questionnaire-answer.component.js.map